// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['uk_UA']  = {
  "name": "uk_UA",
  "day": {
    "abbrev": [
      "нд",
      "пн",
      "вт",
      "ср",
      "чт",
      "пт",
      "сб"
    ],
    "full": [
      "неділя",
      "понеділок",
      "вівторок",
      "середа",
      "четвер",
      "п'ятниця",
      "субота"
    ]
  },
  "month": {
    "abbrev": [
      "січ",
      "лют",
      "бер",
      "кві",
      "тра",
      "чер",
      "лип",
      "сер",
      "вер",
      "жов",
      "лис",
      "гру"
    ],
    "full": [
      "січень",
      "лютий",
      "березень",
      "квітень",
      "травень",
      "червень",
      "липень",
      "серпень",
      "вересень",
      "жовтень",
      "листопад",
      "грудень"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%d.%m.%y",
  "time24": "%T",
  "dateTime": "%a, %d-%b-%Y %X %z",
  "full": "%A, %-d %Om %Y %X %z",
  "time12": ""
}

